
const digest = 'b5a675a413392c95566b4bd9ac79ad24a3acdbc170a7ac64931450daa81684b1';
const classes = {"wrapper":"_wrapper_5kjyv_1","content":"_content_5kjyv_8","title":"_title_5kjyv_15","status":"_status_5kjyv_20","open":"_open_5kjyv_34","closed":"_closed_5kjyv_37","bottom":"_bottom_5kjyv_40","distanceContainer":"_distanceContainer_5kjyv_47","distance":"_distance_5kjyv_47","controls":"_controls_5kjyv_57","arrow":"_arrow_5kjyv_57"};
const css = `._wrapper_5kjyv_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 18px;
  cursor: pointer;
  display: flex;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-right: 10px;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 ._title_5kjyv_15 {
  font-weight: 600;
  font-size: 16px;
  color: #3c3f9c;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 ._status_5kjyv_20 {
  font-size: 14px;
  color: #212357;
  display: flex;
  align-items: center;
  gap: 5px;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 ._status_5kjyv_20::before {
  content: "";
  height: 5px;
  width: 5px;
  display: block;
  border-radius: 100%;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 ._status_5kjyv_20._open_5kjyv_34::before {
  background: green;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 ._status_5kjyv_20._closed_5kjyv_37::before {
  background: red;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 ._bottom_5kjyv_40 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 ._bottom_5kjyv_40 ._distanceContainer_5kjyv_47 {
  display: flex;
  align-items: flex-end;
  height: 100%;
}
._wrapper_5kjyv_1 ._content_5kjyv_8 ._bottom_5kjyv_40 ._distance_5kjyv_47 {
  font-size: 14px;
  color: #212357;
  text-wrap: nowrap;
}
._wrapper_5kjyv_1 ._controls_5kjyv_57 ._arrow_5kjyv_57 {
  height: 50px;
  width: 50px;
  min-width: 50px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(229, 243, 255);
  background: linear-gradient(0deg, rgb(229, 243, 255) 0%, rgb(244, 250, 255) 100%);
  color: #3c3f9c;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  